import { Component, OnInit, HostListener } from '@angular/core';
import { label } from '../constants/labels';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { I18nService } from '@app/core/i18n.service';
import { rolesdef } from '@app/constants/role-def';
import { BaseAPIService } from '@app/Services/api.base.service';
import { ITenantLicenseDetails } from '@app/Models/ITenantLicenseDetails';
import { IAppVersion } from '../Models/IAppVersion';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-sp-sidenav',
  templateUrl: './sp-sidenav.component.html',
  styleUrls: ['./sp-sidenav.component.scss']
})
export class SpSidenavComponent implements OnInit {
  isLoading: boolean = true;

  constructor(private readonly baseService: BaseAPIService, public router: Router,
    private readonly authenticationService: AuthenticationService,
    private readonly i18nService: I18nService,
    private readonly modalService: NgbModal) { }
  public user: any = {};
  labels: any = label;
  public roleCd: string;
  roles: any;
  public isLoggedIn: boolean = false;
  public isInternalUser: boolean = true; // default isInternalUser is true
  public loggedInUser: string | null;
  public urls: any = {};
  public sideNavBar: boolean;
  public all_tenantCount: number;
  public active_tenantCount: number;
  public gracePeriod_tenantCount: number;
  public expired_tenantCount: number;
  public navLinks = [
    { name: this.labels.support, link: environment.supportUrl },
    { name: this.labels.faq, link: environment.faqsUrl },
    { name: this.labels.legal, link: environment.legalUrl },
    { name: this.labels.privacyPolicy, link: environment.privacypolicyUrl },
    { name: this.labels.copyright, link: environment.copyrightUrl },

  ];
  public versionName: string = "";
  public language: string;
  public socialLinks = [
    { icon: 'assets/Facebook.svg', link: environment.facebookUrl },
    { icon: 'assets/Twitter.svg', link: environment.twitterUrl },
    { icon: 'assets/Youtube.svg', link: environment.youtubeUrl },
  ];
  public seLogo: string;
  showReXOTT: boolean = false;
  rexOTTResponse: string = '';

    ngOnInit() {
    this.seLogo = 'assets/schneiderLogo.png';
    this.labels = label;
    this.sideNavBar = false;
    this.language = localStorage.getItem('language');
    this.labels = label;
    this.urls = JSON.parse(this.authenticationService.urls);
    this.isLoggedIn = this.authenticationService.isAuthenticated();
    this.loggedInUser = this.isLoggedIn ? this.authenticationService.authenticatedUser : "";
    
    this.isInternalUser = this.authenticationService.context && JSON.parse(JSON.stringify(this.authenticationService.context.idms)).isInternal !== null ? JSON.parse(JSON.stringify(this.authenticationService.context.idms)).isInternal.toLowerCase() === 'true' : false;
    if (this.language === null) {
      this.language = this.currentLanguage;
    }
    this.roles = rolesdef;
    this.roleCd = this.authenticationService.authenticatedRoleCd;
    console.log('role', this.roleCd);

    this.urls = JSON.parse(this.authenticationService.urls);
    this.GetAppVersion();
  }

  public GetAppVersion() {
    let sessionVersionNo = sessionStorage.getItem('versionNumber');
    if (sessionVersionNo == null || sessionVersionNo == undefined || sessionVersionNo.trim() == "" || sessionVersionNo == "undefined") {
      this.baseService.GET('/Misc/GetAppVersion').subscribe((result: Array<string>) => {
        this.versionName = result[0];
        sessionStorage.setItem('versionNumber', this.versionName);
      });
    } else {
      this.versionName = sessionVersionNo;
    }
  }
  get currentLanguage(): string {
    const sslang = this.i18nService.supportedLanguages.filter(item => item.code === this.i18nService.language);
    return sslang[0].name;
  }

  get languages(): any[] {
    return this.i18nService.supportedLanguages;
  }
  setLanguage(language: any) {
    this.i18nService.language = language.code;

  }

  public logout() {
    this.authenticationService.logout();

  }

  closeModal(){
    this.showReXOTT = false;
  }

  copyToClipboard() {
    if (this.rexOTTResponse) {
      navigator.clipboard.writeText(this.rexOTTResponse).then(() => {
        console.log('RexOTT response copied to clipboard');
        this.showReXOTT = false;
        // Optional: Show a success message to the user
      }).catch(err => {
        console.error('Failed to copy to clipboard:', err);
      });
    }
  }

  openRexOTTpopup() {
    this.showReXOTT = true;
    this.isLoading = true
    this.rexOTTResponse = '';
    const apiUrl = '/REXUtility/GetRexOneTimeToken';
    this.baseService.GetTextWithHeaders(apiUrl, {}).subscribe((response: string) => {
      this.isLoading = false;
      this.rexOTTResponse = response;
    });
  }

}


